import { DropdownMenu as D } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/cn';

export const DropdownMenu = D.Root;
export const DropdownMenuTrigger = D.Trigger;
export const DropdownMenuSeparator = ({ className, ...p }: ComponentProps<typeof D.Separator>) => (
  <D.Separator className={cn('-mx-1 my-1 h-px bg-border', className)} {...p} />
);
export const DropdownMenuLabel = ({ className, ...p }: ComponentProps<typeof D.Label>) => (
  <D.Label className={cn('px-3 py-1.5 text-xs text-muted-foreground', className)} {...p} />
);

export function DropdownMenuContent({ className, sideOffset = 6, ...props }: ComponentProps<typeof D.Content>) {
  return (
    <D.Portal>
      <D.Content
        sideOffset={sideOffset}
        className={cn(
          'oc-pop-in z-[70] min-w-52 overflow-hidden rounded-panel border bg-card p-1 text-card-foreground shadow-[0_12px_32px_-12px_oklch(0.25_0.04_205/0.35)]',
          className,
        )}
        {...props}
      />
    </D.Portal>
  );
}

export function DropdownMenuItem({ className, destructive, ...props }: ComponentProps<typeof D.Item> & { destructive?: boolean }) {
  return (
    <D.Item
      className={cn(
        'flex min-h-9 cursor-pointer items-center gap-2.5 rounded-control px-3 py-2 text-sm outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[highlighted]:bg-muted',
        destructive && 'text-destructive',
        className,
      )}
      {...props}
    />
  );
}
